import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  input: {
    maxWidth: '100%',
  },
  mapHeaderWrapper: {
    marginBottom: 8,
    display: 'flex',
  },
  saveButton: {
    minHeight: '100%',
  },
}));

export default useStyles;
